import { Directive, ElementRef, Renderer2, OnInit, OnDestroy, Input } from '@angular/core';
import { BcPrivilegesFacade } from '@bayclubs/employee-auth';
import { Subscription } from 'rxjs';


@Directive({
    selector: '[bcShowIfPrivilegeDynamic]',
    standalone: false
})
export class BcShowIfPrivilegeDynamicDirective implements OnInit, OnDestroy {
    constructor(private el: ElementRef, private renderer: Renderer2, private privilegeFacade: BcPrivilegesFacade) {}

    private _clubIds: string[];
    private _privileges: string;

    set privileges(value: string) {
        this._privileges = value;
    }
    get privileges(): string {
        return this._privileges;
    }

    @Input()
    set clubIds(value: string[]) {
        this._clubIds = value;
    }
    get clubIds(): string[] {
        return this._clubIds;
    }

    @Input()
    set bcShowIfPrivilegeDynamic(value: string ) {
        this.privileges = value;
    }
    get bcShowIfPrivilegeDynamic(): string  {
        return this.privileges;
    }

    ngOnInit() {
      this.renderer.setAttribute(this.el.nativeElement, 'hidden', 'true');
        this.subscription.add(
          this.privilegeFacade.hasPrivilege(this.privileges, this.clubIds).subscribe(hasPrivilege => {
            hasPrivilege ?
            this.renderer.removeAttribute(this.el.nativeElement, 'hidden')
            :
            this.renderer.setAttribute(this.el.nativeElement, 'hidden', 'true');
          })
        );
    }

    private subscription: Subscription = new Subscription();

    ngOnDestroy() {
      this.subscription?.unsubscribe();
    }
}
